<template>
    <div class='login-container'>
        <div class='login'>
            <p class='title'>{{$t('str.DialogLoopLogin')}}</p>
            <a v-on:click="login('linkedin')" class='socialnetwork'>
                <img src="../../assets/icons/linkedin-button.svg">
            </a>
            <a v-on:click="login('facebook')" class='socialnetwork'>
                <img src="../../assets/icons/facebook-button.svg">
            </a>
            <a v-on:click="login('twitter')" class='socialnetwork'>
                <img src="../../assets/icons/twitter-button.svg">
            </a>
            <a v-on:click='dlLogin'><img src="../../assets/icons/dialogloop-signin-button.svg"></a>
            <p>{{$t('str.NeedAnAccount')}}</p>
            <p><a class="link-register" v-on:click="register">{{$t('str.Register')}}</a></p>
        </div>
        <register v-if="isModal('register')" :service="service" v-on:close='closeModal'></register>
        <dl-login v-if="isModal('dlLogin')" :service="service" v-on:close='closeModal' v-on:register='register'></dl-login>
    </div>
</template>

<script>

import Register from '@/components/login/Register';
import DLLogin from '@/components/login/DLLogin';

export default {

    components: {
        register: Register,
        'dl-login': DLLogin
    },

    props: {
        service: Object
    },

    data() {
        return {
            modal: undefined
        }
    },

    methods: {
        register() {
            this.modal = 'register';
        },

        dlLogin() {
            this.modal = 'dlLogin';
        },

        isModal(type) {
            return type === this.modal;
        },

        closeModal() {
            this.modal = undefined;
        },

        login(socialNetwork) {
            this.service.login(socialNetwork, window.location.href);
        }
    }
};

</script>

<style lang="scss">

.login-container {
    position: relative;
    height: 100%;

    .login {
        margin: 0 auto;
        padding-top: 40px;
        width: 350px;
        font-family: 'Poppins', sans-serif;
        color: #fff;
        position: relative;

        & > * {
            width: 100%;
            text-align: center;
        }

        p {
            margin: 0;
        }

        a {
            cursor: pointer;
        }

        .title {
          margin-bottom: 15px;
        }

        .socialnetwork {
            height: 64px;

            & img {
                margin-bottom: 10px;
            }
        }

        .link-register {
            color: #d4451d;
            text-decoration: none;
        }
    }
}

</style>



// WEBPACK FOOTER //
// Login.vue?4b372ca9